import { config } from '@/pageConfig/faq/fr/fr';
import { FaqPageTemplate } from '@/pageTemplate/FaqPageTemplate';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';

export default function HomePage() {
  const { trackEvent } = useAnalyticsContext();
  // biome-ignore lint/correctness/useExhaustiveDependencies: we just one it on load so no need to add it as a dependency
  useEffect(() => {
    trackEvent('faq_page.viewed', {
      locale: 'fr-FR',
    });
  }, []);

  return <FaqPageTemplate config={config} locale="fr-FR" />;
}
